import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

type ViewFrameImage = {
    idx: number;
    image: HTMLImageElement;
    loaded: boolean;
    error: boolean;
}

@Component({

})
export default class ViewFrame  extends Vue {
    @Prop({ type: String }) bodyUrl!: string;
    @Prop({ type: String, default: null }) content!: string | null;
    @Prop({ type: Number, default: 0 }) endMargin!: number;

    contentLoaded: boolean = false;
    frameImages: ViewFrameImage[] = []; 
    mBodyUrl: string = '';   

    @Watch('content')
    onContentChanged(newVal: string | null) {
        if(newVal != null && newVal.length > 0) {
            this.mountContent(newVal);
        } else {
            this.mBodyUrl = this.bodyUrl;
        }        
    }

    @Watch('bodyUrl')
    onUrlChanged(newVal: string) {
        this.mBodyUrl = newVal;
    }

    mounted() {
        if(this.content != null && this.content.length > 0) {
            this.mountContent(this.content);
        } else {
            this.mBodyUrl = this.bodyUrl;
        }
    }

    mountContent(content: string) {
        var ifrmContent = this.$refs.refIfrmContent as HTMLIFrameElement;
        var contentWindow = ifrmContent.contentWindow;

        if(contentWindow) {
            contentWindow.document.body.innerHTML = content;

            var linkElem = contentWindow.document.createElement("link");
            linkElem.setAttribute("rel", "stylesheet");
            linkElem.setAttribute("type", "text/css");
            linkElem.setAttribute("href", '/cm/gres/libs/synap-editor/SynapEditor/iframeMode/contentsEditStyle.css');
            contentWindow.document.getElementsByTagName("head")[0].appendChild(linkElem);

            // 이미지 최대 너비 제한 스타일 추가
            var styleElem = contentWindow.document.createElement("style");
            styleElem.textContent = `
                body { overflow-x: hidden; max-width: 100%; }
                img { max-width: 100% !important; height: auto !important; }
            `;
            contentWindow.document.getElementsByTagName("head")[0].appendChild(styleElem);

            // 컨텐츠 로딩 후 높이 조정
            this.$nextTick(() => {
                this.mountFrameImages(ifrmContent);
            });
        }
    }

    mountFrameImages(contentFrame: HTMLIFrameElement) {
        if(contentFrame.contentWindow) {
            var contentWindow = contentFrame.contentWindow;
            var ifrmImages = contentWindow.document.images;
            this.adjustScrollHeight(contentFrame);

            if(ifrmImages.length > 0) {
                this.frameImages = [...ifrmImages].map((img, idx) => <ViewFrameImage>{
                    idx: idx,
                    error: false,
                    image: img,
                    loaded: false
                });

                this.frameImages.forEach(frmImg => {
                    if(frmImg.image.complete) {
                        frmImg.loaded = true;
                    } else {
                        frmImg.image.addEventListener( 'load', () => {
                            console.log('viewframe-image-loaded', frmImg.image.src);
                            frmImg.loaded = true; 
                            this.adjustScrollHeight(contentFrame);
                            this.emitContentFrameLoaded();
                        }, false)
    
                        frmImg.image.addEventListener('error', () => {
                            console.log('viewframe-image-error', frmImg.image.src);
                            frmImg.error = true;
                            this.emitContentFrameLoaded();
                        }, false)
                    }
                });
            }

            // 모든 경우에 너비는 100%로 설정
            contentFrame.style.width = "100%";
            this.adjustScrollHeight(contentFrame);

            this.emitContentFrameLoaded();
        }
    }

    emitContentFrameLoaded() {
        if(this.contentLoaded)
            return 

        var ifrmContent = this.$refs.refIfrmContent as HTMLIFrameElement;
        console.log('checkEmitLoaded', this.frameImages);
        if(this.frameImages.length > 0) {
            if(this.frameImages.every(i => i.loaded || i.error || i.image.complete)) {
                this.$emit('contentLoaded', ifrmContent);
                this.contentLoaded = true;
            }
        } else {
            this.$emit('contentLoaded', ifrmContent);
            this.contentLoaded = true;
        }
    }

    onContentFrameLoaded(e: Event | null) {
        this.contentLoaded = false;

        this.$nextTick(() => {
            var ifrmContent = this.$refs.refIfrmContent as HTMLIFrameElement;
            this.mountFrameImages(ifrmContent);         
        })        
    }

    adjustScrollHeight(ifrmContent: HTMLIFrameElement) {
        if(ifrmContent.contentWindow) {
            // 너비는 100%로 고정하고 높이만 컨텐츠에 맞춤
            ifrmContent.style.width = '100%';
            ifrmContent.style.height = (ifrmContent.contentWindow.document.body.scrollHeight + this.endMargin) + 'px';
        }
    }
}